import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=6a97494a&"
import script from "./FormTextArea.vue?vue&type=script&lang=js&"
export * from "./FormTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports